import { generateUUID } from "@/src/shared/utils/uuid";
import type { DSFileUploadItem } from "../types";

export function createFileUploadItem(file: File): DSFileUploadItem {
  return {
    id: `file-${generateUUID()}`,
    file,
    name: file.name,
    size: file.size,
    mimeType: file.type,
  };
}
